<div id="app">
    <router-outlet></router-outlet>
</div>

